module.exports = __webpack_public_path__ + "img/course-1-2.b55fdbe5.jpeg";